const competitions = [
  { compName: "Premier League", id: "2021", code: "PL" },
  { compName: "Bundesliga", id: "2002", code: "BL1" },
  { compName: "Primera Division", id: "2014", code: "PD" },
  { compName: "Ligue 1", id: "2015", code: "FL1" },
  { compName: "Serie A", id: "2019", code: "SA" },
  { compName: "Eredivisie", id: "2003", code: "DED" },
  { compName: "Primeira Liga", id: "2017", code: "PPL" },
  { compName: "Campeonato Brasileiro Série A", id: "2013", code: "BSA" },
  { compName: "Championship", id: "2016", code: "ELC" },
  //   { compName: "UEFA Champions League", id: "2001", code: "CL" },
  //   { compName: "Copa Libertadores", id: "2152", code: "CLI" },
  //   { compName: "FIFA World Cup", id: "2000", code: "WC" },
  //   { compName: "European Championship", id: "2018", code: "EC" },
];

export default competitions;
